// src/pages/NotFound/index.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1>404</h1>
      <h2>页面未找到</h2>
      <p>抱歉，您访问的页面不存在。</p>
      <div className="actions">
        <Link to="/" className="btn-home">返回首页</Link>
        <Link to="/archive" className="btn-archive">查看归档</Link>
      </div>
    </div>
  );
};

export default NotFound;